// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__14Rv0","topBottomGutter":"Layout_topBottomGutter__1Qe8E"};